import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AppService } from '../app.service';
import { environment } from "src/environments/environment";
import { Router} from "@angular/router";

declare var gtag;
declare var fbq;

@Component({
  selector: 'app-requestinfo',
  templateUrl: './requestinfo.component.html',
  styleUrls: ['./requestinfo.component.css']
})
export class RequestinfoComponent implements OnInit {

  constructor(private service: AppService, private fb: FormBuilder,private router: Router) { }

  ngOnInit() {

    if(environment.production){
      this.service.sendEvents("Completerequestinfo", "requestinfo", "RequestInfo");

      fbq('track', "CompleteRequestInfo" , {
        content_type: "requestinfo",
        content_title: this.router.url,
      });
    }

    this.service.setTitle('Get in touch with us');
    this.service.setMetaTags({ property: "og:type", content: 'Property' });
    this.service.setMetaTags({ property: "og:title", content: 'Get in touch with us' });
    this.service.setMetaTags({ name: "keywords", content: 'Get in touch with us' });
    this.service.setMetaTags({ name: "description", content: 'Get in touch with us' });
    this.service.setMetaTags({ property: "og:description", content: 'Get in touch with us' }); 

  }

  info = this.fb.group({
    name: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
    city: ['', Validators.required],
    pincode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
    query: ['', Validators.required]
  });


  get infoControl() { return this.info.controls; }

  infoSubmit: boolean = false;
  infoLoader: boolean = false;
  infoErrorMsg: string = "";
  infoSuccessMsg: string = "";
  infoEnd() {
    this.infoErrorMsg = "";
    this.infoSuccessMsg = "";
    this.infoSubmit = true;

    if (this.info.valid) {
      this.infoLoader = true;
      this.service.post('/requestInfoEnd', this.info.value).subscribe(
        (data: any) => {
          if (data[0].error == '0') {
            this.infoSuccessMsg = data[0].msg;
            this.info.reset();
            this.infoSubmit = false;
          } else {
            this.infoErrorMsg = data[0].msg;
          }

          this.infoLoader = false;
        }, (error: any) => {
          this.infoErrorMsg = error.errorDesc;
          this.infoLoader = false;
        }
      )
    }
  }

  numberOnly(event, length = 0, pointAllow = 0) {
    const iKeyCode = (event.which) ? event.which : event.keyCode;
    if ((pointAllow == 1 && (iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))) || (pointAllow == 0 && (iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57)))) {
      return false;
    } else if (length > 0) {
      var valueLength = (event.target.value).length;
      if (valueLength >= length) {
        return false;
      }
    } else {
      return true;
    }
  }
 
  validateAlpha(evt){
    var keyCode = (evt.which) ? evt.which : evt.keyCode
    if ((keyCode < 65 || keyCode > 90) && (keyCode < 97 || keyCode > 123) && keyCode != 10  && keyCode != 32 && keyCode != 8 && keyCode != 9)

    return false;
    return true;
  }
  
}
